import React, { useState, useEffect } from 'react';
import './UserInput.css';

function UserInput({ onSendMessage, isDisabled, prefilledMessage, placeholder, isReadOnly }) {
  const [message, setMessage] = useState('');
  
  // Update message when prefilledMessage changes
  useEffect(() => {
    if (prefilledMessage && !isDisabled) {
      setMessage(prefilledMessage);
    }
  }, [prefilledMessage, isDisabled]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (message.trim() && !isDisabled && !isReadOnly) {
      onSendMessage(message);
      setMessage('');
    }
  };

  // Determine the appropriate placeholder text
  const getPlaceholder = () => {
    if (placeholder) {
      return placeholder;
    }
    if (isReadOnly) {
      return "Read-only conversation";
    }
    return isDisabled ? "Waiting..." : "Type your message...";
  };

  // Determine which CSS class to use
  const inputClassName = () => {
    if (placeholder === "Conversation locked") {
      return 'message-input locked-chat';
    } else if (isReadOnly) {
      return 'message-input readonly-chat';
    } else {
      return 'message-input';
    }
  };

  return (
    <form className="user-input-form" onSubmit={handleSubmit}>
      <input
        type="text"
        className={inputClassName()}
        placeholder={getPlaceholder()}
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        disabled={isDisabled || isReadOnly}
      />
      <button 
        type="submit" 
        className={`send-button ${message.trim() && !isDisabled && !isReadOnly ? 'active' : ''}`}
        disabled={!message.trim() || isDisabled || isReadOnly}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
          <path fill="currentColor" d="M1.101 21.757L23.8 12.028 1.101 2.3l.011 7.912 13.623 1.816-13.623 1.817-.011 7.912z"></path>
        </svg>
      </button>
    </form>
  );
}

export default UserInput;
